import { render, staticRenderFns } from "./BANDepositDialog.vue?vue&type=template&id=1761fba4&scoped=true&"
import script from "./BANDepositDialog.vue?vue&type=script&lang=ts&"
export * from "./BANDepositDialog.vue?vue&type=script&lang=ts&"
import style0 from "./BANDepositDialog.vue?vue&type=style&index=0&id=1761fba4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761fba4",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QIcon,QCardActions});qInstall(component, 'directives', {ClosePopup});
